<section class="not-found">
    <img src="/assets/images/empty-search.png" class="not-found__image" alt="Not found">
    <h1 class="not-found__title">Página no encontrada</h1>
    <p class="not-found__text">Lo sentimos, podés volver al inicio o usar nuestra menu <span class="is-hidden-mobile">superiór</span></p>
    <a class="button is-primary" href="/">Volver al inicio</a>
</section>